import { useTranslation } from 'react-i18next';
import { ModalVariants } from '../models/Common';
import { useAppDispatch, useAppSelector } from './redux';
import { modalSlice } from '../store/reducers/ModalSlice';
import { AllocationType } from '../models/Accounts';

export const useCallMeBack = () => {
  const dispatch = useAppDispatch();
  const { openModal } = modalSlice.actions;
  const { userInfoState, isUserInfoDownloaded } = useAppSelector((state) => state.userInfoReducer);
  const { t } = useTranslation();

  let site;
  let agreement;
  let address;

  if (isUserInfoDownloaded) {
    site = `Сайт: ${process.env.REACT_APP_NAME || ''}.`;
    agreement = `№ договора: ${userInfoState.id}.`;
    const locationTypeId = userInfoState.Addresses[0].LocationType.id;
    const flat = locationTypeId !== AllocationType.PRIVATE_HOUSE ? ` квартира ${userInfoState.Addresses[0].Flat}` : '';
    const house =
      locationTypeId === AllocationType.PRIVATE_HOUSE
        ? `дом ${userInfoState.Addresses[0].Flat}`
        : `дом ${userInfoState.Addresses[0].House}`;
    address = `Домашний адрес: ул. ${userInfoState.Addresses[0].Street.NameRu} ${house}${flat}.`;
  }

  const callMeBack = () => {
    dispatch(
      openModal({
        modalVariants: ModalVariants.Callback,
        content: {
          title: t('callMeBack.callMeBack'),
          comment: `${site} ${agreement} ${address}`,
        },
      }),
    );
  };

  return { callMeBack };
};
